import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { GuideInfoPopoverComponent } from '../../components/guide-info-popover/guide-info-popover.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BusinessRestServices from '../../services/business-rest.service';
import Config from '../../utils/config.service';
import DialogServices from '../../services/dialog.service';
import RestService from '../../services/core-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalUpdateWorkerAdditionalInfoComponent } from '../modal-update-worker-additional-info/modal-update-worker-additional-info.component';
import { ModalUpdateWorkerInsuranceComponent } from '../modal-update-worker-insurance/modal-update-worker-insurance.component';
import { ModalTerminateWorkerComponent } from '../modal-terminate-worker/modal-terminate-worker.component';
import { ModalTerminatePolicyUserComponent } from '../modal-terminate-worker-policy-user/modal-terminate-worker-policy-user.component';
import { ModalEmployerReminderConfigComponent } from '../modal-employer-reminder-config/modal-employer-reminder-config.component';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	standalone: true,
	selector: 'table-employees',
	templateUrl: './table-employees.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, TranslatePipe, 
		ItemNoContentComponent, LoaderOverlayComponent, GuideInfoPopoverComponent, FormsModule
	]
})
export class TableEmployeesComponent implements OnInit, OnDestroy {
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	private restService: RestService = inject(RestService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() employees: any;
	@Output() employeesChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	searchSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
		
		this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.loadEmployees(true);
		});
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.filter = {
			orderBy: 'created',
			ascending: false
		};
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.includeInsurance = false;
		this.vm.loading = true;
		this.vm.canUserManuallyAddInsurance = this.session.canUserManuallyAddInsurance();
		this.loadEmployees(true, true);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Employees.ADDED, () => {
				this.loadEmployees(true);
				this.vm.currentPage = 0;
			})
		);
		
		this.vm.loadEmployees = this.loadEmployees;
		this.vm.toggleActiveStatus = this.toggleActiveStatus;
		this.vm.toggleAdminAssistantStatus = this.toggleAdminAssistantStatus;
		this.vm.deleteInvitation = this.deleteInvitation;
		this.vm.setFilter = this.setFilter;
		this.vm.hasInsurance = this.hasInsurance;
		this.vm.toggledIncludeInsurance = this.toggledIncludeInsurance;
		this.vm.updateInsurance = this.updateInsurance;
		this.vm.editAdditionalInfo = this.editAdditionalInfo;
		this.vm.editAdditionalInfo2 = this.editAdditionalInfo2;
		this.vm.deactivatePolicy = this.deactivatePolicy;
		this.vm.getEmployeeStatus = this.getEmployeeStatus;
		this.vm.toggleBurgerMenu = this.toggleBurgerMenu;
		this.vm.findBusinessServiceReminderSetting = this.findBusinessServiceReminderSetting;
		
		this.findBusinessServiceReminderSetting();
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadEmployees();
				}
			})
		);
		
		this.restService.getBusinessUserJoinRequests({ start: 0, pageSize: 20 })
			.then((response: any) => {
				// TODO ANGULAR_2 whats missing here?
				console.log(response);
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	hasInsurance() {
		return this.vm.user && this.vm.user.activeInsurancePolicies && this.vm.user.activeInsurancePolicies.length > 0;
	}
	
	toggledIncludeInsurance() {
		this.loadEmployees(true);
		this.vm.currentPage = 0;
	}
	
	loadEmployees(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.employees) ? this.vm.employees.length : 0,
			orderBy: this.vm.filter.orderBy || 'created',
			ascending: this.vm.filter.ascending || false,
			includeInsurance: (this.hasInsurance() ? true : false)
		};
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 1) params.name = this.vm.term.trim();
		this.handleDownloadUrlUpdate();
		
		this.businessRestServices.getWorkers(params, (employees) => {
			if (employees && employees.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			if (isInitial) this.vm.currentPage = 0;
			if (hasLoader) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.employees = isInitial ? employees : this.vm.employees.concat(employees);
					this.employeesChange.emit(this.vm.employees);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			} else {
				this.vm.employees = isInitial ? employees : this.vm.employees.concat(employees);
				this.employeesChange.emit(this.vm.employees);
			}
		});
	}
	
	getEmployeeStatus(employee) {
		if (employee) {
			if (employee.declined) {
				return this.angularFilterHelperService.translate('Employees.Invite_Declined');
			} else if (employee.pending) {
				return this.angularFilterHelperService.translate('Employees.Kombo_Import_Pending');
			} else if (employee.worker && employee.worker.active) {
				return this.angularFilterHelperService.translate('Employees.Active');
			} else if (employee.accepted && employee.worker && !employee.worker.active) {
				return this.angularFilterHelperService.translate('Employees.Deactive');
			} else {
				return this.angularFilterHelperService.translate('Employees.Invite_Pending');
			}
		} else {
			return "";
		}
	}
	
	setFilter(name) {
		this.vm.filter = this.vm.filter || {};
		this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		this.vm.filter.orderBy = name;
		
		this.loadEmployees(true);
	}
	
	handleDownloadUrlUpdate() {
		var url: any = this.config.getRestUrl() + 'rest/business/worker/user-report.xls';
		var params: Array<any> = [];
		params.push("orderBy=" + (this.vm.filter.orderBy ? this.vm.filter.orderBy : "created"));
		params.push("ascending=" + (this.vm.filter.ascending ? this.vm.filter.ascending : false));
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 1) params.push("name=" + this.vm.term.trim());
		if (this.vm.includeInsurance) params.push("includeInsurance=true");
		this.vm.xlsDownloadUrl = url + (params.length ? '?' + params.join('&') : '');
	}
	
	updateInsurance(employee) {
		this.dialogServices.show({
			controller: ModalUpdateWorkerInsuranceComponent,
			businessUserWorker: employee,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
	
	editAdditionalInfo(employeeInvitation) {
		this.dialogServices.show({
			controller: ModalUpdateWorkerAdditionalInfoComponent,
			invitation: employeeInvitation,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
	
	editAdditionalInfo2(employeeInvitation) {
		this.dialogServices.show({
			controller: ModalUpdateWorkerAdditionalInfoComponent,
			invitation: employeeInvitation,
			isSecond: true,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
	
	toggleActiveStatus(employee) {
		if (!employee || !employee.worker || employee.processing) return;
		
		var user: any = this.session.getSession().user;
		
		if (user.businessUserType === 'BUSINESS_CLIENT') {
			if (employee.existingTerminationDate == undefined) {
				if (employee.worker.terminationDate) {
					employee.existingTerminationDate = this.angularHelperService.copy(employee.worker.terminationDate);
				} else {
					employee.existingTerminationDate = false;
				}
			}
			this.dialogServices.show({
				controller: ModalTerminateWorkerComponent,
				businessUserWorker: employee,
				clickOutsideToClose: false,
				escapeToClose: false,
				multiple: false
			});
		} else {
			var worker: any = employee.worker;
			employee.processing = true;
			var handleUpdate: any = () => {
				worker.active = !worker.active;
				employee.processing = false;
			};
			
			var params = { id: worker.employee.id };
			if (worker.active) {
				this.businessRestServices.deActivateWorker(params, {}, handleUpdate);
			} else {
				this.businessRestServices.activateWorker(params, {}, handleUpdate);
			}
		}
	}
	
	toggleAdminAssistantStatus(employee) {
		if (!employee || !employee.worker || employee.processing) return;
		
		var worker: any = employee.worker;
		employee.processing = true;
		var handleUpdate: any = () => {
			worker.adminAssistantRights = !worker.adminAssistantRights;
			employee.processing = false;
		};
		this.businessRestServices.toggleAdminAssistantStatus({ id: worker.employee.id, status: !worker.adminAssistantRights }, handleUpdate);
	}
	
	deactivatePolicy(wallet, policy, employee) {
		if (!employee || !employee.worker || employee.processing || !policy || !wallet || wallet.deactivated) return;
		
		var user: any = this.session.getSession().user;
		
		if (user.businessUserType === 'BUSINESS_CLIENT') {			
			this.dialogServices.show({
				controller: ModalTerminatePolicyUserComponent,
				providedData: {
					wallet: wallet,
					businessUserWorker: employee,
					policy: policy
				},
				clickOutsideToClose: false,
				escapeToClose: false,
				multiple: false
			});
		}
	}
	
	deleteInvitation(employee) {
		if (!employee || employee.processing) return;
		
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Employees.Confirm_Delete_Invitation')
				.replace('%s', employee.firstName + ' ' + employee.lastName),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				employee.processing = true;
				var handleUpdate: any = () => {
					employee.deleted = true;
					employee.processing = false;
				};
				this.businessRestServices.deleteInvitation({ invitationId: employee.id }, handleUpdate);
			}
		});
	}
	
	toggleBurgerMenu() {
		this.dialogServices.show({
			controller: ModalEmployerReminderConfigComponent,
			businessServiceSetting: this.vm.businessServiceSetting
		});
	}
	
	findBusinessServiceReminderSetting() {
		this.restService.getFindBusinessServiceReminderSetting({ id: this.vm.user.id })
			.then((data) => {
				this.vm.businessServiceSetting = data;
				console.log(data);
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
}